module.exports = __webpack_public_path__ + "0264bc49ee3cf8f94da1ac96e77e4483.png";